export default "__VITE_ASSET__C70U2qAU__"